export default function (field) {
  return function (item) {
    if (!field || !item) {
      return null;
    }

    if (field.required) {
      if (!(field.code in item)) {
        return "required";
      } else {
        const val = item[field.code];
        if (val === null || val === undefined || val === "") {
          return "required";
        }
      }
    }

    return null;
  };
}
